import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactElement, type ReactNode } from 'react';
import { Button as AriaButton, Dialog, DialogTrigger, Popover } from 'react-aria-components';
import { BsXLg } from 'react-icons/bs';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import Button from '@/ui/button/button';

// import styles from '@/features/listing/components/listings-filters/listing-view-select/listing-view-select.module.scss';
import styles from './listing-filter-new.module.scss';
interface ListingFilterNewProps {
  listingFilterName: ListingsFilterName;
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  buttonText: string | number | ReactElement;
  dialogTitle: string;
  children: ReactNode;
  hideButtons?: boolean;
  isPopoverOpen?: boolean;
  setPopoverOpen?: (isOpen: boolean) => void;
  onClear?: () => void;
  onApplyClick?: () => void;
  activeFiltersCount?: number;
}
export default function ListingFilterNew(props) {
  const $ = _c(43);
  const {
    activeFiltersCount: t0,
    buttonText,
    children,
    dialogTitle,
    isPopoverOpen,
    listingFilterName,
    hideButtons: t1,
    onApplyClick,
    onClear,
    onFilterDisplayChange,
    setPopoverOpen
  } = props;
  const activeFiltersCount = t0 === undefined ? 0 : t0;
  const hideButtons = t1 === undefined ? false : t1;
  const translationsFiltersCommon = useTranslations("listing.filters.common");
  let t2;
  if ($[0] !== listingFilterName || $[1] !== onFilterDisplayChange || $[2] !== setPopoverOpen) {
    t2 = () => {
      onFilterDisplayChange(listingFilterName);
      if (setPopoverOpen) {
        setPopoverOpen(true);
      }
    };
    $[0] = listingFilterName;
    $[1] = onFilterDisplayChange;
    $[2] = setPopoverOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpenViewPopover = t2;
  let t3;
  if ($[4] !== onFilterDisplayChange || $[5] !== setPopoverOpen) {
    t3 = () => {
      onFilterDisplayChange(null);
      if (setPopoverOpen) {
        setPopoverOpen(false);
      }
    };
    $[4] = onFilterDisplayChange;
    $[5] = setPopoverOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCloseViewPopover = t3;
  let t4;
  if ($[7] !== handleCloseViewPopover || $[8] !== onApplyClick) {
    t4 = () => {
      if (onApplyClick) {
        handleCloseViewPopover();
        onApplyClick();
      }
    };
    $[7] = handleCloseViewPopover;
    $[8] = onApplyClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleApplyClick = t4;
  let t5;
  if ($[10] !== activeFiltersCount) {
    t5 = activeFiltersCount > 0 && <div className={styles.listingFilter_activeFiltersCount}>{activeFiltersCount}</div>;
    $[10] = activeFiltersCount;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== buttonText || $[13] !== handleOpenViewPopover || $[14] !== t5) {
    t6 = <AriaButton className={styles.listingFilter_showDropdown} onPress={handleOpenViewPopover}>{t5}{buttonText}</AriaButton>;
    $[12] = buttonText;
    $[13] = handleOpenViewPopover;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      outline: "none"
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== dialogTitle) {
    t8 = <p className={styles.listingFilter_title}>{dialogTitle}</p>;
    $[17] = dialogTitle;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <BsXLg />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== handleCloseViewPopover) {
    t10 = <AriaButton className={styles.listingFilter_closeButton} onPress={handleCloseViewPopover} aria-label="close dropdown">{t9}</AriaButton>;
    $[20] = handleCloseViewPopover;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className={styles.listingFilter_top}>{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== children) {
    t12 = <div className={styles.listingFilter_children}>{children}</div>;
    $[25] = children;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== handleApplyClick || $[28] !== hideButtons || $[29] !== onClear || $[30] !== translationsFiltersCommon) {
    t13 = !hideButtons && <div className={styles.listingFilter_bottom}><Button onClick={onClear} type="button" element="button" size="md" variant="ghost">{translationsFiltersCommon("clear")}</Button><Button onClick={handleApplyClick} element="button" size="md">{translationsFiltersCommon("show-results")}</Button></div>;
    $[27] = handleApplyClick;
    $[28] = hideButtons;
    $[29] = onClear;
    $[30] = translationsFiltersCommon;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13) {
    t14 = <Dialog style={t7}>{t11}{t12}{t13}</Dialog>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== isPopoverOpen || $[37] !== setPopoverOpen || $[38] !== t14) {
    t15 = <Popover className={styles.listingFilter_popover} isOpen={isPopoverOpen} onOpenChange={setPopoverOpen}>{t14}</Popover>;
    $[36] = isPopoverOpen;
    $[37] = setPopoverOpen;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15 || $[41] !== t6) {
    t16 = <DialogTrigger>{t6}{t15}</DialogTrigger>;
    $[40] = t15;
    $[41] = t6;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}